import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateWeekNote } from 'actions/projects';
import NoteModal from './NoteModal';

const mapDispatchToProps = dispatch => ({
  updateWeekNote: bindActionCreators(updateWeekNote, dispatch),
});

export default connect(
  null,
  mapDispatchToProps,
)(NoteModal);



// WEBPACK FOOTER //
// ./src/components/NoteModal/container.js